export default function (data) {
  const card = document.createElement("article");
  card.className = "horizontal-card";
  card.innerHTML = /*html*/`
  <div class="horizontal-card--preview">
    <img src="${(data && data.img) ? data.img : ''}">
    <h6>${data.type}</h6>
    <h2>${(data.about) ? data.about : ""}</h2>
    <a href="https://www.google.com/travel/hotels/Waldoboro?g2lb=2502548%2C2503780%2C4258168%2C4270442%2C4306835%2C4317915%2C4328159%2C4347306%2C4371334%2C4401769%2C4419364%2C4463263%2C4463666%2C4464736%2C4466981%2C4472151%2C4482194%2C4482438%2C4495816%2C4496891%2C4270859%2C4284970%2C4291517%2C4464911&hl=en-US&gl=us&un=1&ap=aAE&q=${encodeURI(data.type)}%20waldoboro%20me&rp=EM2HzKCD2eelfRCErqnju6qZrVcQi9enp4G28u19EKuahIfw_8mCUzgBQABIAqIBDVdhbGRvYm9ybywgTUU&ictx=1&sa=X&ved=0CAAQ5JsGahcKEwiw0r3hldbuAhUAAAAAHQAAAAAQQQ&utm_campaign=sharing&utm_medium=link&utm_source=htls&ts=CAESABoxChMSDzoNV2FsZG9ib3JvLCBNRRoAEhoSFAoHCOUPEAcYEBIHCOUPEAcYEhgCMgIIASoPCgsoAUoCIAE6A1VTRBoA">${data.type}s near Waldoboro</a>
  </div>
  <div class="horizontal-card--info">
    <!-- 			<div class="progress-container">
  <div class="progress"></div>
  <span class="progress-text">
  6/9 Challenges
  </span>
  </div> -->
    <h6></h6>
    <h2>${data.name}</h2>
    <p>${data.subtitle}</p>
    <a href="${data.url}"><button class="btn">Reserve</button></a>
  </div>
  `
  return card
}

function externalLink() {
  return `
  <svg style="width: 10px;margin-bottom: 4px;margin-right: 4px;"aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"></path></svg>
  `
}